import {connect} from 'react-redux';

import {createSelector, makeMapStateToProps} from '../../../../../../srcCommon/helpers/reselectHelpers';
import {TopicCommentUnfurlModel} from '../../../../../models/api/commentUnfurlModel';
import {AppState} from '../../../../../store/appState';
import {getTopics} from '../../../../../store/data/dataSelectors';
import {getFindTeammate} from '../../../../../store/data/teammates/lazyTeammatesSelectors';
import {CommentViewerTopicUnfurl} from './commentViewerTopicUnfurl';

/*
 * Props.
 */

interface CommentViewerTopicUnfurlContainerProps {
  unfurl: TopicCommentUnfurlModel;
  isInteractionDisabled?: boolean;
}

/*
 * Selectors.
 */

function getTopicFromProps(_state: AppState, props: CommentViewerTopicUnfurlContainerProps) {
  return props.unfurl.topic;
}

function getTopicId(_state: AppState, props: CommentViewerTopicUnfurlContainerProps) {
  return props.unfurl.topicId;
}

function makeGetTopic() {
  return createSelector([getTopicId, getTopics, getTopicFromProps], (topicId, topics, topic) => {
    if (topic) {
      return topic;
    }
    if (!topicId) {
      return undefined;
    }
    return topics[topicId];
  });
}

function makeGetTopicUnfurlOwner(getTopic: ReturnType<typeof makeGetTopic>) {
  return createSelector([getFindTeammate, getTopic], (findTeammate, topic) => {
    if (!topic?.ownerId) {
      return undefined;
    }

    return findTeammate(topic.ownerId, 'CommentViewerTopicUnfurlContainer');
  });
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<CommentViewerTopicUnfurlContainerProps>()(() => {
  const getTopic = makeGetTopic();
  return {
    topic: getTopic,
    owner: makeGetTopicUnfurlOwner(getTopic),
  };
});

export const CommentViewerTopicUnfurlContainer = connect(mapStateToProps)(CommentViewerTopicUnfurl);
